module.exports = {"140823100":"桐城镇","140823101":"郭家庄镇","140823102":"畖底镇","140823103":"薛店镇","140823104":"东镇镇","140823105":"礼元镇","140823106":"河底镇","140823107":"阳隅镇","140823108":"侯村镇","140823109":"裴社镇","140823204":"后宫乡","140823205":"石门乡","140823400":"闻喜县社区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140823.json
// module id = 424
// module chunks = 0